import { formatCurrency, formatMetric } from '@/utils/format-utils';

import { TabType } from '@/routes/dashboards/shared-types';

export const formatTooltipValue = (value: unknown, initialTab: TabType) => {
  if (typeof value !== 'number') {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.join(', ');
    return JSON.stringify(value);
  }

  switch (initialTab) {
    case 'revenue':
    case 'directRevenue':
    case 'influencedRevenue':
      return formatCurrency(value);
    default:
      return formatMetric(value, 0);
  }
};
